import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, googleAuthProvider, signInWithPopup } from '../../../firebase/firebase.js';

const Login = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const result = await signInWithPopup(auth, googleAuthProvider);
      if (result.user) {
        navigate('/profile');
      }
    } catch (err) {
      console.error('Error during Google login:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ backgroundColor: '#000000', zIndex: 1050 }}
    >
      <div 
        className="bg-white rounded p-5 text-center shadow-lg" 
        style={{ 
          maxWidth: '450px', 
          width: '90%',
          borderRadius: '16px'
        }}
      >
        <h2 className="mb-3" style={{ fontWeight: '700', color: '#1a1a1a' }}>
          ¡Bienvenid@ a Rem Enterprises AI!
        </h2>
        <p className="mb-4" style={{ color: '#6c757d', fontSize: '1rem', lineHeight: '1.6' }}>
          Aquí puedes explorar y personalizar productos únicos creados con inteligencia artificial.
          Desde cuadros y almohadones hasta remeras, ¡diseña a tu gusto con tecnología avanzada!
        </p>
        <button
          className="btn btn-lg w-100 d-flex align-items-center justify-content-center"
          onClick={handleGoogleLogin}
          disabled={loading}
          style={{
            backgroundColor: '#1a1a1a',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontWeight: '500',
            padding: '14px 24px',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
          }}
          onMouseEnter={(e) => {
            if (!loading) {
              e.currentTarget.style.backgroundColor = '#1f8e38';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(31, 142, 56, 0.3)';
            }
          }}
          onMouseLeave={(e) => {
            if (!loading) {
              e.currentTarget.style.backgroundColor = '#1a1a1a';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
            }
          }}
        >
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: '12px' }}
          >
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          {loading ? 'Iniciando sesión...' : 'Iniciar sesión con Google'}
        </button>
        {error && (
          <div 
            className="alert alert-danger mt-3" 
            style={{ 
              borderRadius: '8px',
              fontSize: '0.9rem'
            }}
          >
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
